import React from 'react'
import * as pathname from './pathname'
import { MODULES, GROUPS, METHOD } from '../../utils/constants/roles'
import OwnFuelStationCompetencies from '../../views/fuel-stations/own-fuel-stations/own-fuel-station/OwnFuelStationCompetencies'
import OwnFuelStationPurchasePrices from '../../views/fuel-stations/own-fuel-stations/own-fuel-station/OwnFuelStationPurchasePrices'
import OwnFuelStationData from '../../views/fuel-stations/own-fuel-stations/own-fuel-station/OwnFuelStationData'
import OwnFuelStationPrices from '../../views/fuel-stations/own-fuel-stations/own-fuel-station/OwnFuelStationPrices'
import OwnFuelStationTanks from '../../views/fuel-stations/own-fuel-stations/own-fuel-station/OwnFuelStationTanks'
import OwnFuelStationConsumption from '../../views/fuel-stations/own-fuel-stations/own-fuel-station/OwnFuelStationConsumption'
import OwnFuelStationMargin from '../../views/fuel-stations/own-fuel-stations/own-fuel-station/OwnFuelStationMargin'

const ownFuelStationsRoutes = [
  {
    path: pathname.ownFuelStation.DATA(':id'),
    name: 'fuelStationsOwnData',
    element: <OwnFuelStationData />,
    role: {
      module: MODULES.FUELSTATIONS,
      group: GROUPS.OWN,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.ownFuelStation.COMPETENCES(':id'),
    name: 'fuelStationsOwnCompetencies',
    element: <OwnFuelStationCompetencies />,
    role: {
      module: MODULES.FUELSTATIONS,
      group: GROUPS.OWN,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.ownFuelStation.PRICES(':id'),
    name: 'FuelStationOwnMineturPrices',
    element: <OwnFuelStationPrices />,
    role: {
      module: MODULES.FUELSTATIONS,
      group: GROUPS.OWN,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.ownFuelStation.PURCHASE_PRICES(':id'),
    name: 'FuelStationOwnPurchasePrices',
    element: <OwnFuelStationPurchasePrices />,
    role: {
      module: MODULES.PURCHASE_FUEL,
      group: GROUPS.PROPOSAL,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.ownFuelStation.MARGIN(':id'),
    name: 'margin',
    element: <OwnFuelStationMargin />,
    role: {
      module: MODULES.PURCHASE_FUEL,
      group: GROUPS.MARGIN,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.ownFuelStation.TANKS(':id'),
    name: 'FuelStationOwnPurchasePrices',
    element: <OwnFuelStationTanks />,
    role: { module: MODULES.ALVIC, group: GROUPS.TANKS, method: METHOD.GET },
  },
  {
    path: pathname.ownFuelStation.CONSUMPTION_PREVENTION(':id'),
    name: 'FuelStationOwnPurchasePrices',
    element: <OwnFuelStationConsumption />,
    role: {
      module: MODULES.ALVIC,
      group: GROUPS.CONSUMPTION,
      method: METHOD.GET,
    },
  },
]

export default ownFuelStationsRoutes
